export const convertDistance = (meters, unit) => {
  const roundedMeters = Math.round(meters);
  if (unit === "yards") {
    return Math.round(roundedMeters * 1.09361);
  }
  return roundedMeters;
}; 